<template>
    <div class="doc-list">
        <div class="doc-list__title text_15 text_bold">{{ $t("docs") }}</div>
        <nuxt-link :to="`/dokumenty/${slug}/`" v-for="(title, slug) in docs" :key="slug">
            <div class="text_13">
                <span>{{ title }}</span>
            </div>
        </nuxt-link>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    layout: "help",
    name: "Dokumenty",
    head() {
        return {
            title: this.$i18n.t("docs") + " | " + this.$i18n.t("pps_title"),
        };
    },
    async asyncData({ $axios }) {
        const docs = await $axios.get("/api/documents");

        const data = {
            docs: docs.data,
        };
        return data;
    },
    watch: {
        async langust() {
            await this.$nuxt.refresh();
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        crumbs() {
            return [
                {
                    name: this.$i18n.t("customer_help"),
                },
                { name: this.$i18n.t("docs") },
            ];
        },
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.doc-list {
    display: block;
    display: flex;
    flex-direction: column;
    @media @sm {
        background: #fff;
        padding: 24px 16px;
        margin: 0 -16px;
        margin-bottom: -32px;
    }
    &__title {
        margin-bottom: 32px;
    }
    a + a {
        margin-top: 16px;
    }
}
</style>
